/* eslint-disable */
export default {
  confirmation: '確認',
  confirmMergeToConference: '添加至電話會議？',
  mergeToConference: '合併',
  conferenceCall: '電話會議',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
